import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import BulkImageGenerationModal from '~/javascript/components/admin/page_editor/BulkImageGenerationModal.vue'

/**
 * Stimulus controller for bulk image generation - mounts Vue modal component
 *
 * Usage:
 *   <div data-controller="admin--bulk-image"
 *        data-admin--bulk-image-website-id-value="<%= website.id %>"
 *        data-admin--bulk-image-page-id-value="<%= page.id %>"
 *        data-admin--bulk-image-scope-value="page">
 *     <button data-action="click->admin--bulk-image#openModal">Generate Images</button>
 *   </div>
 */
export default class extends Controller {
  static values = {
    websiteId: String,
    pageId: String,
    scope: { type: String, default: 'page' }
  }

  connect() {
    this.vueApp = null
    this.vueInstance = null
    this.mountPoint = null
  }

  disconnect() {
    this.unmountVue()
  }

  openModal(event) {
    event?.preventDefault()

    // Get scope from the trigger element if provided
    const scope = event?.currentTarget?.dataset?.scope || this.scopeValue

    // Mount Vue app if not already mounted
    if (!this.vueApp) {
      this.mountVue(scope)
    }

    // Open the modal
    if (this.vueInstance) {
      this.vueInstance.open()
    }
  }

  mountVue(scope) {
    // Create mount point
    this.mountPoint = document.createElement('div')
    this.mountPoint.id = 'bulk-image-modal-mount'
    document.body.appendChild(this.mountPoint)

    // Create Vue app
    this.vueApp = createApp(BulkImageGenerationModal, {
      websiteId: this.websiteIdValue,
      pageId: this.pageIdValue,
      scope: scope,
      onClose: () => {
        // Optional: cleanup or refresh after modal closes
      }
    })

    // Mount and store instance reference
    this.vueInstance = this.vueApp.mount(this.mountPoint)
  }

  unmountVue() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
      this.vueInstance = null
    }
    if (this.mountPoint) {
      this.mountPoint.remove()
      this.mountPoint = null
    }
  }
}
